import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Zap, ArrowRight, FileBadge } from "lucide-react";
import { useAtest } from "./AtestProvider";

const links = [
  { to: "/", label: "Početna" },
  { to: "/proizvodi", label: "Proizvodi" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { open: openAtest } = useAtest();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 backdrop-blur-md transition-colors duration-300 ${
        scrolled
          ? "bg-white/90 border-b border-neutral-200"
          : "bg-white/60 border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="relative w-10 h-10 rounded-xl bg-neutral-950 flex items-center justify-center overflow-hidden">
            <Zap className="w-5 h-5 text-amber-400 relative z-10" />
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-lg text-neutral-950">Elorte-Medarić</div>
            <div className="text-[10px] uppercase tracking-widest text-neutral-500">PVC elektro ormari</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium link-underline ${
                  isActive ? "text-neutral-950" : "text-neutral-600 hover:text-neutral-950"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/kontakt"
            className="btn-primary inline-flex items-center gap-2 bg-neutral-950 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-amber-500 hover:text-neutral-950"
          >
            Zatraži ponudu
            <ArrowRight className="w-4 h-4" />
          </Link>
          <button
            onClick={openAtest}
            title="Pogledaj atest / certifikat kvaliteta"
            className="btn-primary inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-neutral-950 px-4 py-2.5 rounded-full text-sm font-semibold"
          >
            <FileBadge className="w-4 h-4" />
            ATEST
          </button>
        </nav>

        <button
          className="md:hidden p-2 rounded-lg text-neutral-900 hover:bg-neutral-100"
          onClick={() => setOpen(!open)}
          aria-label="Meni"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-sm font-medium ${
                    isActive
                      ? "bg-neutral-950 text-white"
                      : "text-neutral-800 hover:bg-neutral-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); openAtest(); }}
              className="mt-2 inline-flex items-center justify-center gap-2 bg-amber-400 text-neutral-950 px-4 py-3 rounded-lg text-sm font-semibold"
            >
              <FileBadge className="w-4 h-4" /> ATEST
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
